package amazon.lastmile.inject

import app.nestbridge.feature.designcatalog.presentation.DesignCatalogPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DesignCatalogPresenterFactory::class)
public interface AppNestbridgeFeatureDesigncatalogPresentationDesignCatalogPresenterFactory {
  @Provides
  @IntoSet
  public fun provideDesignCatalogPresenterFactoryFactoryMultibinding(designCatalogPresenterFactory: DesignCatalogPresenterFactory): Presenter.Factory = designCatalogPresenterFactory
}
